import AuthorizationHelper from '@auth/services/authorization.helper';

export const MainTaxCertificateRoutes = [
  {
    path: 'activity-certificates',
    name: 'admin-activity-certificates',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.tax_certificates],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-tax-certificates" */ '@tax-certificates/pages/activity-tax-certificates.vue'
      ),
  },
];
